module.exports = [
  {
    code: '3303',
    name: 'Leather',
    color: 'Black',
  },
  {
    code: '8593',
    name: 'Metal',
    color: 'Silver',
  },
  {
    code: '1106',
    name: 'Cotton',
    color: 'White',
  },
];
